var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 1058,
    viewBox: "0 0 673 1058",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 753.318,
    y: -15,
    width: 452.864,
    height: 1086.57,
    rx: 38,
    transform: "rotate(45 753.318 -15)",
    fill: "#C9D3E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleBlue);
export default __webpack_public_path__ + "static/media/rectangle-blue.66a78494b6e99eadd3325adf79011631.svg";
export { ForwardRef as ReactComponent };